import { Button, ButtonProps, SxProps, Theme } from '@mui/material';
import React, { ReactNode } from 'react';

const HEADER_BUTTON_SX: SxProps<Theme> = { all: 'unset', cursor: 'pointer' };

export interface HeaderCollapseButtonProps {
    contentCollapsed: boolean;
    panelContentId: string;
    onClick: ButtonProps['onClick'];
    children: ReactNode;
}

export const HeaderCollapseButton = ({
    contentCollapsed,
    panelContentId,
    onClick,
    children
}: HeaderCollapseButtonProps) => {
    return (
        <Button
            type="button"
            disableRipple
            sx={HEADER_BUTTON_SX}
            aria-expanded={!contentCollapsed}
            aria-controls={panelContentId}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};
